import { MdShoppingBasket } from "react-icons/md"
import { motion } from "framer-motion"
import { useStateValue } from "../../context/StateProvider";

const LoginAction = ({ text, mobile }: { text?: string, mobile?: boolean }) => {

    const [{ showCart, cartItems }, dispatch] = useStateValue();
    const handleToggleCart = () => {
      dispatch({
        type: "TOGGLE_CART",
        showCart: !showCart,
      });
    };

  return (
     <motion.div
              whileTap={{ scale: 0.9 }}
              whileHover={{ scale: 1.1 }}
              initial={{ opacity: 0, x: 200 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 200 }}
              className="relative flex items-center justify-center text-textColor"
              onClick={handleToggleCart}
            >
              <MdShoppingBasket size={'32px'} className="text-4xl cursor-pointer" />
              {cartItems && (
                <div className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-cartNumBg flex items-center justify-center">
                  <p className="text-sm text-white font-semibold">
                    {cartItems.length}
                  </p>
                </div>
              )}
            </motion.div> 
  )
}

export default LoginAction